<template>
  <TransitionGroup
    :appear="appear"
    :name="transitionName"
    :tag="groupTag"
    @enter="onEnter"
  >
    <slot />
  </TransitionGroup>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface AIAssistantBaseChatTransitionProps {
  appear?: boolean;
  delay?: number;
  disabled?: boolean;
  group?: boolean;
  groupTag?: string;
  staggerDelay?: number;
}

const {
  delay = 0,
  disabled,
  staggerDelay = 250,
  groupTag = "div",
} = defineProps<AIAssistantBaseChatTransitionProps>();

const transitionName = computed(() => (disabled ? "" : "chat"));

function onEnter(el: Element) {
  if (!(el as HTMLElement).dataset.index) return;

  Object.assign((el as HTMLElement).style, {
    transitionDelay: `${Number((el as HTMLElement).dataset.index) * staggerDelay + delay}ms`,
  });
}
</script>

<style lang="scss">
.chat-move,
.chat-enter-active,
.chat-leave-active {
  transition: all 500ms ease-out;
}

.chat-enter-from,
.chat-leave-to {
  transform: translateY(60px);
  opacity: 0;
}

.chat-leave-active {
  position: absolute;
}
</style>
